export const TEXTAREA_ID = 'Textarea';
export const TEXTAREA_SLOT_ID = 'TextareaSlot';
